import { useState } from "react";
import { ChevronDown, ChevronRight, Info } from "lucide-react";
import type { Assumption } from "@/lib/api/assistant";

const LEVEL_STYLE: Record<Assumption["level"], string> = {
  low: "bg-slate-100 text-slate-700 border-slate-200",
  medium: "bg-amber-50 text-amber-800 border-amber-200",
  high: "bg-emerald-50 text-emerald-800 border-emerald-200",
};

export function AssumptionsPanel({ assumptions }: { assumptions: Assumption[] }) {
  const [open, setOpen] = useState(false);
  if (assumptions.length === 0) return null;

  return (
    <div className="border border-slate-200 rounded-lg bg-white overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full px-4 py-2.5 flex items-center justify-between hover:bg-slate-50"
      >
        <div className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <Info className="h-4 w-4 text-slate-500" />
          Assumptions
          <span className="text-xs text-slate-500">({assumptions.length})</span>
        </div>
        {open ? (
          <ChevronDown className="h-4 w-4 text-slate-500" />
        ) : (
          <ChevronRight className="h-4 w-4 text-slate-500" />
        )}
      </button>
      {open && (
        <div className="border-t border-slate-200 divide-y divide-slate-100">
          {assumptions.map((a, i) => (
            <div key={i} className="px-4 py-2.5 flex items-start gap-3 text-sm">
              <span
                className={`text-[10px] uppercase font-semibold px-1.5 py-0.5 rounded border ${LEVEL_STYLE[a.level]}`}
              >
                {a.level}
              </span>
              <div className="flex-1 min-w-0">
                <div className="text-slate-800">{a.message}</div>
                <div className="text-[11px] text-slate-500 mt-0.5 font-mono">
                  {a.code}
                  {a.field_path ? ` · ${a.field_path}` : ""}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
